import productImage1 from "./assets/img/photo-1.png";
import productImage2 from "./assets/img/photo-2.png";
import productImage3 from "./assets/img/photo-3.png";
import productImage4 from "./assets/img/photo-4.png";
import productImage5 from "./assets/img/photo-5.png";
import productImage6 from "./assets/img/photo-6.png";
import productImage7 from "./assets/img/photo-7.png";
import productImage8 from "./assets/img/photo-8.png";
import productImage9 from "./assets/img/photo-9.png";
import productImage10 from "./assets/img/photo-10.png";
import productImage11 from "./assets/img/photo-11.png";
import productImage12 from "./assets/img/photo-12.png";
import productImage13 from "./assets/img/photo-13.png";
import productImage14 from "./assets/img/photo-14.png";
import productImage15 from "./assets/img/photo-15.png";
import productImage16 from "./assets/img/photo-16.png";
import productImage17 from "./assets/img/photo-17.png";
import productImage18 from "./assets/img/photo-18.png";
import productImage19 from "./assets/img/photo-19.png";
import productImage20 from "./assets/img/photo-20.png";
import background1 from "./assets/img/background-1.jpg";
import background2 from "./assets/img/background-2.jpg";
import background3 from "./assets/img/background-3.jpg";
import background4 from "./assets/img/background-4.jpg";

export const products = [
  {
    id: "123",
    name: "Black Wallet",
    price: "60000.00",
    description:
      "Sleek black wallet, perfect for keeping your essentials organized and secure.",
    imageUrl: productImage1,
    averageRating: "5.0",
    category: "Accessories",
  },
  {
    id: "234",
    name: "Black iphone",
    price: "4000.00",
    description:
      "High-end smartphone with a sophisticated black finish, offering advanced features.",
    imageUrl: productImage2,
    averageRating: "5.0",
    category: "Electronics",
  },
  {
    id: "345",
    name: "Beer Can",
    price: "90.00",
    description: "Refreshing beer in a convenient can, ideal for any occasion.",
    imageUrl: productImage3,
    averageRating: "4.7",
    category: "Beverages",
  },
  {
    id: "456",
    name: "Powder Fondation",
    price: "190.00",
    description:
      "Smooth powder foundation providing a flawless finish for all skin types.",
    imageUrl: productImage4,
    averageRating: "5.0",
    category: "Skincare",
  },
  {
    id: "567",
    name: "Pigmentation Blush",
    price: "200.00",
    description:
      "Vibrant blush designed to enhance your natural complexion with a healthy glow.",
    imageUrl: productImage5,
    averageRating: "4.9",
    category: "Skincare",
  },
  {
    id: "678",
    name: "Sun Glasses",
    price: "200.00",
    description:
      "Stylish sunglasses offering UV protection and a fashionable look.",
    imageUrl: productImage6,
    averageRating: "5.0",
    category: "Accessories",
  },
  {
    id: "789",
    name: "Dark Shoes",
    price: "290.00",
    description:
      "Trendy dark-colored shoes versatile enough for casual and formal wear.",
    imageUrl: productImage7,
    averageRating: "4.8",
    category: "Footwear",
  },
  {
    id: "890",
    name: "Sport Shoes",
    price: "400.00",
    description:
      "Durable sport shoes engineered for optimal performance during activities.",
    imageUrl: productImage8,
    averageRating: "5.0",
    category: "Footwear",
  },
  {
    id: "901",
    name: "Lens",
    price: "1940.00",
    description:
      "Precision camera lens ensuring high-quality photography with sharp images.",
    imageUrl: productImage9,
    averageRating: "4.6",
    category: "Electronics",
  },
  {
    id: "109",
    name: "Woman Shoes",
    price: "330.00",
    description: "Elegant women's shoes combining style and comfort.",
    imageUrl: productImage10,
    averageRating: "4.9",
    category: "Footwear",
  },
  {
    id: "987",
    name: "Camera",
    price: "2230.00",
    description:
      "Professional-grade camera capturing stunning photos and videos.",
    imageUrl: productImage11,
    averageRating: "5.0",
    category: "Electronics",
  },
  {
    id: "908",
    name: "White Phone",
    price: "3180.00",
    description: "Sleek white phone featuring state-of-the-art technology.",
    imageUrl: productImage12,
    averageRating: "5.0",
    category: "Electronics",
  },
  {
    id: "111",
    name: "Wooden Chair",
    price: "650.00",
    description:
      "Sturdy and elegant wooden chair adding a touch of class to any room.",
    imageUrl: productImage13,
    averageRating: "4.5",
    category: "Furniture",
  },
  {
    id: "222",
    name: "Office Desk",
    price: "250.00",
    description:
      "Functional office desk designed to enhance productivity and organization.",
    imageUrl: productImage14,
    averageRating: "4.7",
    category: "Furniture",
  },
  {
    id: "333",
    name: "Table Lamp",
    price: "70.00",
    description:
      "Modern table lamp providing excellent lighting and complementing any decor.",
    imageUrl: productImage15,
    averageRating: "4.8",
    category: "Furniture",
  },
  {
    id: "444",
    name: "Bookscase",
    price: "520.00",
    description:
      "Stylish bookcase perfect for organizing books and decorative items.",
    imageUrl: productImage16,
    averageRating: "4.8",
    category: "Furniture",
  },
  {
    id: "555",
    name: "Wardrobe",
    price: "750.00",
    description:
      "Spacious wardrobe offering ample storage for clothing and accessories.",
    imageUrl: productImage17,
    averageRating: "4.9",
    category: "Furniture",
  },
  {
    id: "666",
    name: "Couch",
    price: "2350.00",
    description:
      "Comfortable and stylish couch perfect for relaxing and lounging.",
    imageUrl: productImage18,
    averageRating: "5.0",
    category: "Furniture",
  },
  {
    id: "919",
    name: "Red Wine",
    price: "320.00",
    description:
      "Rich and flavorful red wine, ideal for pairing with meals or special occasions.",
    imageUrl: productImage19,
    averageRating: "4.9",
    category: "Beverages",
  },
  {
    id: "999",
    name: "Green Tea",
    price: "100.00",
    description:
      "Refreshing green tea with a smooth taste, perfect for a relaxing break.",
    imageUrl: productImage20,
    averageRating: "4.8",
    category: "Beverages",
  },
];

export const background = [
  {
    id: "1",
    category: "Electronics",
    imageUrl: background1,
    caption: "Empower your world with cutting-edge tech",
  },
  {
    id: "2",
    category: "Furniture",
    imageUrl: background2,
    caption: "Elevate your space with style and comfort",
  },
  {
    id: "3",
    category: "Accessories",
    imageUrl: background3,
    caption: "Accessorize your life with elegance and flair",
  },
  {
    id: "4",
    category: "Beverages",
    imageUrl: background4,
    caption: "Sip, savor, and indulge in the finest flavors",
  },
];

export const cartItems = [products[0], products[2], products[3], products[5]];
